@if (groups$ | async; as groups) {
    @if (groups.length > 1) {
        <div class="px-4 py-2 groups-container flex-grow-1 overflow-auto">
            <div class="section-header d-flex align-items-center justify-content-between mb-2">
                <span class="text-uppercase fw-semibold small text-muted">
                    <i class="fa fa-database me-1"></i> Base Dati
                </span>
                <span class="badge bg-secondary-subtle text-light rounded-pill px-2 py-0 small">
                    {{ groups.length }}
                </span>
            </div>
            <div class="d-flex flex-column gap-2">
                @for (group of groups; track group.id) {
                    <div class="group-item">
                        <div 
                            class="group-card text-start w-100 d-flex align-items-center p-1 rounded-3"
                            [class.active]="isGroupActive(group.id)"
                            [class.selected-parent]="selectedGroupId() === group.id && !isGroupActive(group.id)">
                            <button
                                type="button"
                                class="group-select-btn text-start flex-grow-1 d-flex align-items-center p-1 text-truncate"
                                (click)="selectGroup(group)"
                                [title]="group.description">
                                <div class="group-icon-wrapper d-flex align-items-center justify-content-center me-2">
                                    <i class="fa fa-database group-icon"></i>
                                </div>
                                <div class="group-info text-truncate flex-grow-1">
                                    <span class="group-desc d-block text-truncate fw-medium">
                                        {{ group.description }}
                                    </span>
                                    <small class="group-name text-muted text-truncate d-block">
                                        {{ group.name }}
                                    </small>
                                </div>
                            </button>
                            <button 
                                type="button" 
                                class="btn btn-link p-0 text-muted toggle-btn ms-1 me-1"
                                (click)="toggleExpand(group.id, $event)"
                                [attr.aria-label]="isExpanded(group.id) ? 'Comprimi sotto-menu' : 'Espandi sotto-menu'">
                                <i class="fa" [class.fa-chevron-down]="isExpanded(group.id)" [class.fa-chevron-right]="!isExpanded(group.id)"></i>
                            </button>
                        </div>

                        <!-- Sotto-menu per ciascuna Base Dati -->
                        @if (isExpanded(group.id)) {
                            <div class="submenu-container mt-1 mb-2">
                                <div class="px-2 mb-2">
                                    <button 
                                        type="button" 
                                        class="btn btn-sm btn-primary w-100 d-flex align-items-center justify-content-center gap-2 new-chat-btn"
                                        (click)="startNewChat(group.id, $event)">
                                        <i class="fa fa-plus small"></i>
                                        <span>Nuova Chat</span>
                                    </button>
                                </div>
                                <ul class="submenu-list list-unstyled d-flex flex-column gap-1 mb-0">
                                    <li>
                                        <a 
                                            [routerLink]="['/conversation-history']" 
                                            [queryParams]="{ index: group.id }"
                                            class="submenu-link d-flex align-items-center px-2 py-1 rounded text-decoration-none"
                                            [class.active]="isItemActive('/conversation-history', group.id)">
                                            <i class="far fa-comments me-2 submenu-icon"></i>
                                            <span class="text-truncate">Storico Conversazioni</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a 
                                            [routerLink]="['/documents-history']" 
                                            [queryParams]="{ index: group.id }"
                                            class="submenu-link d-flex align-items-center px-2 py-1 rounded text-decoration-none"
                                            [class.active]="isItemActive('/documents-history', group.id)">
                                            <i class="far fa-file me-2 submenu-icon"></i>
                                            <span class="text-truncate">Storico Documenti</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    } @else {
        <!-- Vista indice singolo o default: interfaccia pulita senza lista di basi dati -->
        <ul class="list-unstyled px-4 single-nav-list flex-grow-1">
            <li class="mb-4">
                <button type="button" (click)="startNewChat(groups[0]?.id)" class="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2">
                    <i class="fa fa-plus small"></i>
                    <span>Nuova Chat</span>
                </button>
            </li>
            <li class="p-2 text-truncate w-100 text-start">
                <a 
                    [routerLink]="['/conversation-history']" 
                    [queryParams]="groups[0] ? { index: groups[0].id } : null"
                    class="single-nav-link"
                    [class.active]="isItemActive('/conversation-history', groups[0]?.id)">
                    <i class="btn-icon far fa-comments me-2" aria-hidden="true"></i>
                    <span class="text-truncate">Storico Conversazioni</span>
                </a>
            </li>
            <li class="p-2 text-truncate w-100 text-start">
                <a 
                    [routerLink]="['/documents-history']" 
                    [queryParams]="groups[0] ? { index: groups[0].id } : null"
                    class="single-nav-link"
                    [class.active]="isItemActive('/documents-history', groups[0]?.id)">
                    <i class="btn-icon far fa-file me-2" aria-hidden="true"></i>
                    <span class="text-truncate">Storico Documenti</span>
                </a>
            </li>
        </ul>
    }
}
